import { useQuery } from "@apollo/client/react";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

import { isSelfHostedDistribution } from "utils/distribution";

import { GET_ENABLED_CLOUD_INTEGRATIONS } from "./gql";
import { useSelfHostedEnabledCloudIntegrationsStore } from "./useStore";

const isSelfHosted = isSelfHostedDistribution();

const useSelfHostedEnabledCloudIntegrations = () => {
  const { setIsLoading, setAwsIntegrationsEnabled, setAzureIntegrationsEnabled } =
    useSelfHostedEnabledCloudIntegrationsStore(
      useShallow((state) => ({
        setIsLoading: state.setIsLoading,
        setAwsIntegrationsEnabled: state.setAwsIntegrationsEnabled,
        setAzureIntegrationsEnabled: state.setAzureIntegrationsEnabled,
      }))
    );

  const { loading, data } = useQuery(GET_ENABLED_CLOUD_INTEGRATIONS, {
    skip: !isSelfHosted,
  });

  useEffect(() => {
    if (data) {
      setAwsIntegrationsEnabled(data.awsIntegrationsEnabled);
      setAzureIntegrationsEnabled(data.azureIntegrationsEnabled);
    }
  }, [data, setAwsIntegrationsEnabled, setAzureIntegrationsEnabled]);

  setIsLoading(loading);

  return undefined;
};

export default useSelfHostedEnabledCloudIntegrations;
